import { Box } from '@mui/material';
import React from 'react';

import { spaces } from '../../../../../assets/styles/themes/tokens';

const MuiCardBaseShortContentWrapper: React.FC<{
	children: React.ReactNode;
	isTruncated: boolean;
}> = ({ children, isTruncated }) => (
	<Box
		sx={{
			paddingTop: spaces.xxs,
			paddingBottom: spaces.xxs,
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',
			gap: isTruncated ? 'unset' : spaces.md,
		}}
	>
		{children}
	</Box>
);

export default MuiCardBaseShortContentWrapper;
